// src/components/StatusFilterComponent.jsx
import React from 'react';
import './StatusFilterComponent.css';

const StatusFilterComponent = ({ 
  selectedStatus, 
  onStatusChange,
  statuses = [
    { value: 'all', label: 'All Status' },
    { value: 'PENDING', label: 'Pending' },
    { value: 'COMPLETED', label: 'Completed' },
    { value: 'CANCELED', label: 'Canceled' }
  ]
}) => {
  return (
    <div className="status-filter-container">
      <select
        value={selectedStatus}
        onChange={(e) => onStatusChange(e.target.value)}
        className="status-select"
        aria-label="Filter by status"
      >
        {statuses.map(status => (
          <option key={status.value} value={status.value}>
            {status.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default StatusFilterComponent;
